module.exports = __webpack_public_path__ + "static/media/openflo.528b7215.svg";